(function () {
  "use strict";

  var root = document.getElementById("exos-assistant-root");
  if (!root) return;
  var endpoint = window.EXOS_ASSISTANT_ENDPOINT;
  // Bail if the endpoint is unset or still the deploy-time placeholder.
  if (!endpoint || endpoint === "WORKER_ENDPOINT_HERE") return;

  var MOBILE_QUERY = "(max-width: 600px)";
  var CONTACT_URL = "https://exosdoor.ca/pages/contact";
  var CONTACT_MSG = "Sorry, something went wrong. Please try again, or reach us through our [Contact page](" + CONTACT_URL + ").";
  var BUSY_MSG = "I'm getting a lot of questions right now. Give it a few seconds and ask me again.";
  var DAY_LIMIT_MSG = "This chat has hit its daily limit. Please reach us through our [Contact page](" + CONTACT_URL + ").";
  // Static notice HTML appended below a kept-but-flawed answer (never user/model content).
  var NOTE_TRUNCATED = '<p><em>…I had to cut that answer short. Say "continue" and I\'ll pick up where I left off.</em></p>';
  var NOTE_HICCUP = "<p><em>The connection hiccuped, so part of that answer may be missing. Ask again if something looks off.</em></p>";
  var STREAM_TIMEOUT_MS = 30000; // abort a silently-stalled stream so the widget can recover
  var FEEDBACK_ENDPOINT = endpoint.replace(/\/chat\/?$/, "/feedback");
  var CONVO_KEY = "exosAssistantConvo";
  // Tappable starter questions shown on first open, so a first-time visitor never faces an
  // empty box. Each one has a strong, verified answer path in the assistant's knowledge.
  var STARTERS = [
    "What size door do I need?",
    "How much is a complete door with frame?",
    "How do I measure my old door?",
    "Do you deliver to my area?"
  ];
  // Product thumbnails for card rendering, keyed by /products/ handle. Regenerate alongside
  // knowledge/data/images.json when the catalog changes (same photos, width=240).
  var PRODUCT_THUMBS = {
    "2panel": "https://cdn.shopify.com/s/files/1/0709/4268/7285/files/2_Panel_exos.jpg?v=1774400329&width=240",
    "1panelflat": "https://cdn.shopify.com/s/files/1/0709/4268/7285/files/1planelflat_e5e7563c-e481-4946-adf8-3d855047e41e.jpg?v=1774401896&width=240",
    "2panelflat": "https://cdn.shopify.com/s/files/1/0709/4268/7285/files/2panel_black_hardware_c92939bb-4a17-4b70-a1cd-4fa367cdd044.jpg?v=1781319047&width=240",
    "1-panel-shaker": "https://cdn.shopify.com/s/files/1/0709/4268/7285/files/exoss1.jpg?v=1781317103&width=240",
    "2-panel-shaker": "https://cdn.shopify.com/s/files/1/0709/4268/7285/files/exoss2.jpg?v=1781317078&width=240",
    "weiser-winston-handle": "https://cdn.shopify.com/s/files/1/0709/4268/7285/files/wpassexos_20c62488-3712-40f9-90d0-5ad059e55065.jpg?v=1779111630&width=240",
    "satin-nickel-weiser-daylon-door-handle": "https://cdn.shopify.com/s/files/1/0709/4268/7285/files/dpassexos.jpg?v=1779112452&width=240",
    "3-inch-hinges": "https://cdn.shopify.com/s/files/1/0709/4268/7285/files/IMG_60813.jpg?v=1781839527&width=240",
    "black-3-inch-hinges": "https://cdn.shopify.com/s/files/1/0709/4268/7285/files/IMG_60822.jpg?v=1781839527&width=240",
    "door-jambs": "https://cdn.shopify.com/s/files/1/0709/4268/7285/files/jamb_profile.jpg?v=1782087516&width=240",
    "finger-joint-pine-primed-jamb": "https://cdn.shopify.com/s/files/1/0709/4268/7285/files/jambw.jpg?v=1782088077&width=240"
  };

  var messages = [];          // {role, content} — conversation sent to the worker
  var openState = false;
  var greeted = false;        // show the opening greeting at most once
  var convoGen = 0;           // bumped by "Start over" — stale in-flight work must not touch the new conversation
  var activeCtrl = null;      // AbortController of the in-flight send, so reset can cancel it
  // Conversation lives only in memory for the current page view (see saveConvo below).

  function isMobile() { return !!(window.matchMedia && window.matchMedia(MOBILE_QUERY).matches); }

  /* ---------- safe markdown (HTML-escape FIRST, then add our own tags) ---------- */
  function escapeHtml(s) {
    return String(s == null ? "" : s)
      .replace(/&/g, "&amp;")
      .replace(/</g, "&lt;")
      .replace(/>/g, "&gt;")
      .replace(/"/g, "&quot;")   // escape quotes so a URL can't break out of an href="..."
      .replace(/'/g, "&#39;");
  }
  function inline(s) {
    // URLs run through escapeHtml first, so any " or ' inside them is already encoded; the
    // char classes below also exclude quotes/brackets as defense in depth.
    // Images: ONLY from the store's own CDN (the model is whitelisted to store photos, and
    // this keeps any other host out even if it drifts). Click opens the full-size photo.
    s = s.replace(/!\[([^\]]*)\]\((https:\/\/cdn\.shopify\.com\/[^\s)"'<>]+)\)/g, '<a class="exos-assistant__imgwrap" href="$2" target="_blank" rel="noopener noreferrer"><img class="exos-assistant__img" src="$2" alt="$1" loading="lazy"></a>');
    s = s.replace(/!\[[^\]]*\]\(https?:\/\/[^\s)"'<>]+\)/g, ""); // drop any non-whitelisted image outright
    s = s.replace(/\[([^\]]+)\]\((https?:\/\/[^\s)"'<>]+)\)/g, '<a href="$2" target="_blank" rel="noopener noreferrer">$1</a>');
    s = s.replace(/(^|[\s(])(https?:\/\/[^\s<)"'<>]+)/g, '$1<a href="$2" target="_blank" rel="noopener noreferrer">$2</a>');
    s = s.replace(/\*\*([^*\n]+)\*\*/g, "<strong>$1</strong>");
    return s;
  }
  function mdToHtml(text) {
    var lines = escapeHtml(text).split("\n");
    var html = "", inList = false, inCards = false;
    function closeBlocks() {
      if (inList) { html += "</ul>"; inList = false; }
      if (inCards) { html += "</div>"; inCards = false; }
    }
    for (var i = 0; i < lines.length; i++) {
      // A bullet whose content is a bold product link renders as a tappable product CARD
      // (thumbnail from PRODUCT_THUMBS, price from the line's own text). Everything is
      // already HTML-escaped; the url char class excludes quotes/brackets.
      var cm = lines[i].match(/^\s*[-*]\s+\[\*\*(.+?)\*\*\]\((https:\/\/exosdoor\.ca\/products\/([a-z0-9-]+)[^\s)"'<>]*)\)\s*(.*)$/);
      if (cm) {
        if (inList) { html += "</ul>"; inList = false; }
        if (!inCards) { html += '<div class="exos-assistant__cards">'; inCards = true; }
        var thumb = Object.prototype.hasOwnProperty.call(PRODUCT_THUMBS, cm[3]) ? PRODUCT_THUMBS[cm[3]] : "";
        // Split the tail into a short price tag and a wrapping description (the model
        // sometimes adds one) — a long tail in the nowrap price slot crushed the name to
        // one letter per line and forced a horizontal scrollbar. Nested markdown links are
        // flattened to text so they can't split the card <a> apart.
        var tail = cm[4].replace(/^[\s\-–—:]+/, "").replace(/\[([^\]]+)\]\(https?:\/\/[^\s)"'<>]+\)/g, "$1").replace(/\*\*/g, "");
        var pm = tail.match(/^\$[\d][\d,.]*/);
        var price = pm ? pm[0].replace(/[.,]+$/, "") : "";
        var desc = (pm ? tail.slice(pm[0].length) : tail).replace(/^[\s.,;:!-]+/, "");
        if (desc.length > 90) desc = desc.slice(0, 90).replace(/&[#a-zA-Z0-9]*$/, "") + "…";
        html += '<a class="exos-assistant__card" href="' + cm[2] + '" target="_blank" rel="noopener noreferrer">' +
          (thumb ? '<img src="' + thumb + '" alt="" loading="lazy">' : "") +
          '<span class="exos-assistant__card-body">' +
            '<span class="exos-assistant__card-name">' + cm[1] + "</span>" +
            (desc ? '<span class="exos-assistant__card-desc">' + desc + "</span>" : "") +
          "</span>" +
          (price ? '<span class="exos-assistant__card-price">' + price + "</span>" : "") +
          "</a>";
        continue;
      }
      var m = lines[i].match(/^\s*[-*]\s+(.*)$/);
      if (m) {
        if (inCards) { html += "</div>"; inCards = false; }
        if (!inList) { html += "<ul>"; inList = true; }
        html += "<li>" + inline(m[1]) + "</li>";
      } else {
        closeBlocks();
        if (lines[i].trim() !== "") html += "<p>" + inline(lines[i]) + "</p>";
      }
    }
    closeBlocks();
    return html;
  }

  /* ---------- build the UI ---------- */
  root.className = "exos-assistant";
  root.innerHTML =
    '<div class="exos-assistant__backdrop is-hidden" aria-hidden="true"></div>' +
    '<div class="exos-assistant__panel is-hidden" role="dialog" aria-modal="true" aria-label="Exos Door Assistant">' +
      '<div class="exos-assistant__header">' +
        '<span class="exos-assistant__title">Exos Door Assistant</span>' +
        '<span class="exos-assistant__header-actions">' +
          '<button type="button" class="exos-assistant__reset">Start over</button>' +
          '<button type="button" class="exos-assistant__close" aria-label="Close chat">&times;</button>' +
        '</span>' +
      '</div>' +
      '<div class="exos-assistant__messages" role="log" aria-live="polite"></div>' +
      '<form class="exos-assistant__form">' +
        '<input class="exos-assistant__input" type="text" placeholder="Ask about doors, sizes, measuring…" autocomplete="off" maxlength="2000" aria-label="Type your question">' +
        '<button class="exos-assistant__send" type="submit" aria-label="Send">Send</button>' +
      '</form>' +
    '</div>' +
    '<button type="button" class="exos-assistant__bubble" aria-label="Open the Exos Door assistant" aria-expanded="false">' +
      '<svg aria-hidden="true" focusable="false" width="28" height="28" viewBox="0 0 24 24" fill="currentColor">' +
        '<path d="M12 3C6.48 3 2 6.58 2 11c0 2.05.98 3.92 2.6 5.34-.13 1.3-.62 2.51-1.32 3.41-.22.28-.02.69.34.65 1.9-.22 3.36-.85 4.43-1.55C9.2 18.62 10.56 19 12 19c5.52 0 10-3.58 10-8s-4.48-8-10-8z"/>' +
      '</svg>' +
      '<span class="exos-assistant__badge" aria-hidden="true">1</span>' +
    '</button>';

  // Mount at the end of <body> so the fixed widget sits in the root stacking context.
  if (root.parentNode !== document.body) document.body.appendChild(root);

  var panel = root.querySelector(".exos-assistant__panel");
  var header = root.querySelector(".exos-assistant__header");
  var backdrop = root.querySelector(".exos-assistant__backdrop");
  var bubble = root.querySelector(".exos-assistant__bubble");
  var messagesEl = root.querySelector(".exos-assistant__messages");
  var form = root.querySelector(".exos-assistant__form");
  var input = root.querySelector(".exos-assistant__input");
  var closeBtn = root.querySelector(".exos-assistant__close");
  var resetBtn = root.querySelector(".exos-assistant__reset");
  var sendBtn = root.querySelector(".exos-assistant__send");

  // Auto-scroll follows the newest message only while the reader is already at (or near)
  // the bottom — scrolling up to reread must not be yanked back down by streaming tokens.
  var stickToBottom = true;
  messagesEl.addEventListener("scroll", function () {
    stickToBottom = messagesEl.scrollHeight - messagesEl.scrollTop - messagesEl.clientHeight < 60;
  });
  function scrollToBottom(force) {
    if (force) stickToBottom = true;
    if (stickToBottom) messagesEl.scrollTop = messagesEl.scrollHeight;
  }

  function addBubble(role, text) {
    var el = document.createElement("div");
    el.className = "exos-assistant__msg exos-assistant__msg--" + role;
    if (role === "assistant") el.innerHTML = mdToHtml(text); // markdown, rendered safely
    else el.textContent = text;                              // user text is never HTML
    messagesEl.appendChild(el);
    scrollToBottom(true);
    return el;
  }

  /* ---------- question chips (starter questions + model-suggested follow-ups) ---------- */
  var chipsEl = null;
  function renderChipRow(list) {
    removeChips();
    if (!list || !list.length) return;
    chipsEl = document.createElement("div");
    chipsEl.className = "exos-assistant__chips";
    for (var i = 0; i < list.length; i++) {
      (function (text) {
        var b = document.createElement("button");
        b.type = "button";
        b.className = "exos-assistant__chip";
        b.textContent = text;
        b.addEventListener("click", function () {
          input.value = text;
          if (typeof form.requestSubmit === "function") form.requestSubmit();
          else form.dispatchEvent(new Event("submit", { bubbles: true, cancelable: true }));
        });
        chipsEl.appendChild(b);
      })(list[i]);
    }
    messagesEl.appendChild(chipsEl);
    scrollToBottom();
  }
  function renderStarterChips() {
    // Only for an empty conversation, and never over a restored (failed-send) draft —
    // a chip click would silently overwrite the question sitting in the input.
    if (messages.length > 0 || input.value) return;
    renderChipRow(STARTERS);
  }
  function removeChips() {
    if (chipsEl && chipsEl.parentNode) chipsEl.parentNode.removeChild(chipsEl);
    chipsEl = null;
  }

  /* ---------- exit feedback (asked ONCE per visit, when closing after a real answer) ---------- */
  var exitFbEl = null;
  var FB_ASKED_KEY = "exosAssistantFbAsked";
  function fbAsked() { try { return !!sessionStorage.getItem(FB_ASKED_KEY); } catch (e) { return false; } }
  function markFbAsked() { try { sessionStorage.setItem(FB_ASKED_KEY, "1"); } catch (e) {} }
  function shouldAskFeedback() {
    if (fbAsked()) return false;
    for (var i = 0; i < messages.length; i++) if (messages[i].role === "assistant") return true; // greeting isn't in messages
    return false;
  }
  function lastQA() {
    var qa = { q: "", a: "" };
    for (var i = messages.length - 1; i >= 0; i--) {
      if (!qa.a && messages[i].role === "assistant") qa.a = messages[i].content;
      else if (qa.a && messages[i].role === "user") { qa.q = messages[i].content; break; }
    }
    return qa;
  }
  function hideExitFeedback() {
    if (exitFbEl && exitFbEl.parentNode) exitFbEl.parentNode.removeChild(exitFbEl);
    exitFbEl = null;
  }
  function showExitFeedback() {
    if (exitFbEl) return;
    exitFbEl = document.createElement("div");
    exitFbEl.className = "exos-assistant__exitfb";
    exitFbEl.style.top = header.offsetHeight + "px"; // keep the header (and its ×) usable above the overlay
    var card = document.createElement("div");
    card.className = "exos-assistant__exitfb-card";
    var msg = document.createElement("p");
    msg.textContent = "Before you go, was this helpful?";
    card.appendChild(msg);
    var row = document.createElement("div");
    row.className = "exos-assistant__exitfb-btns";
    var pairs = [["Yes", "up"], ["No", "down"]];
    for (var i = 0; i < pairs.length; i++) {
      (function (text, vote) {
        var b = document.createElement("button");
        b.type = "button";
        b.className = "exos-assistant__fb-btn";
        b.textContent = text;
        b.addEventListener("click", function () {
          markFbAsked();
          var qa = lastQA();
          try {
            fetch(FEEDBACK_ENDPOINT, {
              method: "POST",
              headers: { "content-type": "application/json" },
              body: JSON.stringify({ vote: vote, question: qa.q.slice(0, 2000), answer: qa.a.slice(0, 4000) })
            });
          } catch (e) { /* fire-and-forget */ }
          row.style.display = "none"; // no double votes
          msg.textContent = "Thanks for the feedback!";
          setTimeout(reallyClose, 600);
        });
        row.appendChild(b);
      })(pairs[i][0], pairs[i][1]);
    }
    card.appendChild(row);
    exitFbEl.appendChild(card);
    panel.appendChild(exitFbEl);
    try { row.firstChild.focus(); } catch (e) { /* keyboard users land on Yes */ }
  }

  // The conversation survives page navigation within the visit (sessionStorage): a shopper
  // can ask about sizing, go look at a door, and come back without re-explaining. Cleared
  // when the tab closes or via the header's "Start over" button. (Supersedes the earlier
  // in-memory-only behavior — owner opted back in on 2026-07-02.)
  function saveConvo() {
    try { sessionStorage.setItem(CONVO_KEY, JSON.stringify({ m: messages.slice(-20), g: greeted, ts: Date.now() })); } catch (e) {}
  }
  function restoreConvo() {
    try {
      // An explicit RELOAD starts a fresh chat (owner preference); only navigating between
      // pages carries the conversation. Stale chats (over an hour idle) also start fresh.
      var nav = (performance.getEntriesByType && performance.getEntriesByType("navigation")[0]) || null;
      if (nav && nav.type === "reload") { sessionStorage.removeItem(CONVO_KEY); return; }
      var d = JSON.parse(sessionStorage.getItem(CONVO_KEY) || "null");
      if (!d || !Array.isArray(d.m) || !d.m.length) return;
      if (!d.ts || Date.now() - d.ts > 3600000) { sessionStorage.removeItem(CONVO_KEY); return; }
      for (var i = 0; i < d.m.length; i++) {
        var t = d.m[i];
        if (!t || (t.role !== "user" && t.role !== "assistant") || typeof t.content !== "string") return; // corrupt — start fresh
      }
      messages = d.m;
      greeted = !!d.g;
      for (var j = 0; j < messages.length; j++) addBubble(messages[j].role, messages[j].content);
    } catch (e) { /* storage unavailable — stay in-memory */ }
  }
  restoreConvo();

  function showGreeting() {
    if (!greeted && messages.length === 0) { addBubble("assistant", "Hi! I'm the Exos Door assistant. Ask me anything about our doors, frames, and hardware, or any general door question. New to all this? No question is too basic."); greeted = true; }
    renderStarterChips();
  }

  function resetConvo() {
    convoGen++; // invalidate any in-flight send's post-stream work
    if (activeCtrl) { try { activeCtrl.abort(); } catch (e) {} }
    hideExitFeedback(); // a stale exit prompt must not survive into the fresh conversation
    messages = [];
    greeted = false;
    chipsEl = null; // lived inside messagesEl, cleared with it
    messagesEl.innerHTML = "";
    input.value = "";
    try { sessionStorage.removeItem(CONVO_KEY); } catch (e) {}
    showGreeting();
    if (!isMobile()) input.focus();
  }

  /* ---------- lock the underlying page so it can't scroll while the sheet is open ---------- */
  var savedScrollY = 0, scrollLocked = false;
  function lockScroll() {
    if (scrollLocked) return;
    savedScrollY = window.scrollY || window.pageYOffset || 0;
    document.documentElement.style.overflow = "hidden";
    document.body.style.overflow = "hidden";
    scrollLocked = true;
  }
  function unlockScroll() {
    if (!scrollLocked) return;
    document.documentElement.style.overflow = "";
    document.body.style.overflow = "";
    scrollLocked = false;
    window.scrollTo(0, savedScrollY);
  }
  // The real iOS scroll lock: while open on mobile, only the messages list may scroll;
  // any other touch-drag (page behind, header, the gap) is cancelled so nothing else moves.
  document.addEventListener("touchmove", function (e) {
    if (!openState || !isMobile()) return;
    if (messagesEl.contains(e.target) || form.contains(e.target)) return;
    e.preventDefault();
  }, { passive: false });

  /* ---------- viewport-aware layout ---------- */
  function applyLayout() {
    // Mobile-only backdrop: swallows stray taps on the page sliver above the open sheet
    // (one accidental tap on the site header used to navigate away and erase the chat).
    backdrop.classList.toggle("is-hidden", !(openState && isMobile()));
    if (!openState || !isMobile()) {
      panel.style.cssText = "";    // hand sizing back to the stylesheet (desktop / hidden)
      backdrop.style.cssText = ""; // drop any stale visual-viewport glue
      return;
    }
    var vv = window.visualViewport;
    var fullH = window.innerHeight || document.documentElement.clientHeight;
    var visibleH = vv ? vv.height : fullH;
    var offsetTop = vv ? vv.offsetTop : 0;
    // Full-page chat on mobile (owner, 2026-07-02): the panel always fills the VISUAL
    // viewport exactly — keyboard closed that's the whole screen, keyboard open it's the
    // space above the keyboard. No keyboard detection needed anymore. Anchored via TOP
    // (never CSS bottom:0 — iOS keeps fixed bottom:0 on the layout viewport, which slides
    // UNDER the keyboard). This is NOT the old pure-CSS full-screen that broke with the
    // keyboard; sizing stays JS-glued to window.visualViewport.
    panel.style.position = "fixed";
    panel.style.left = "0px";
    panel.style.right = "0px";
    panel.style.width = "100%";
    panel.style.maxWidth = "100%";
    panel.style.maxHeight = "none";
    panel.style.borderRadius = "0";
    panel.style.top = Math.round(offsetTop) + "px";
    panel.style.bottom = "auto";
    panel.style.height = Math.round(visibleH) + "px";
    // Glue the dimmer to the visual viewport too (fixed inset:0 tracks the layout viewport,
    // which iOS pans away from when the keyboard opens, leaving an undimmed page strip).
    backdrop.style.top = Math.round(offsetTop) + "px";
    backdrop.style.bottom = "auto";
    backdrop.style.height = Math.round(visibleH) + "px";
  }

  /* ---------- focus management (modal dialog) ---------- */
  function focusables() {
    var f = [resetBtn, closeBtn, input, sendBtn];
    if (exitFbEl) { // exit-prompt buttons live after the form in DOM order
      var bs = exitFbEl.getElementsByTagName("button");
      for (var i = 0; i < bs.length; i++) f.push(bs[i]);
    }
    return f.filter(function (el) { return el && !el.disabled; });
  }
  // Document-level so ESC works no matter where focus is (notably the mobile path that does
  // not auto-focus the input), and so Tab is trapped inside the open dialog.
  function onKeydown(e) {
    if (!openState) return;
    if (e.key === "Escape") { e.preventDefault(); close(); return; }
    if (e.key !== "Tab") return;
    var f = focusables();
    if (!f.length) return;
    var first = f[0], last = f[f.length - 1], active = document.activeElement;
    if (!panel.contains(active)) { e.preventDefault(); first.focus(); return; }
    if (e.shiftKey && active === first) { e.preventDefault(); last.focus(); }
    else if (!e.shiftKey && active === last) { e.preventDefault(); first.focus(); }
  }

  function open(opts) {
    if (openState) return;
    openState = true;
    clearBadge(); // visitor engaged — drop the attention badge for the rest of the session
    if (isMobile()) lockScroll(); // freeze the page so opening/typing can't scroll it
    panel.classList.remove("is-hidden");
    bubble.classList.add("is-hidden");
    bubble.setAttribute("aria-expanded", "true");
    showGreeting();
    applyLayout();
    document.addEventListener("keydown", onKeydown);
    // Only take focus when the user actively opened the chat — NOT on the timed auto-open
    // (stealing focus unprompted is a disruptive context change). Never auto-focus on mobile.
    if (!isMobile() && opts && opts.focus) input.focus();
    scrollToBottom();
  }
  function reallyClose() {
    if (!openState) return;
    hideExitFeedback();
    openState = false;
    panel.classList.add("is-hidden");
    bubble.classList.remove("is-hidden");
    bubble.setAttribute("aria-expanded", "false");
    applyLayout();
    unlockScroll();
    document.removeEventListener("keydown", onKeydown);
    if (!isMobile()) bubble.focus(); // avoid a focus-driven scroll on phones
  }
  function close() {
    if (!openState) return;
    // First close attempt after a real conversation: ask for a quick verdict. A second
    // close (×, ESC, or backdrop) still gets them out — trapped visitors vote with anger.
    if (exitFbEl) { markFbAsked(); reallyClose(); return; }
    if (shouldAskFeedback()) { showExitFeedback(); return; }
    reallyClose();
  }

  bubble.addEventListener("click", function () { openState ? close() : open({ focus: true }); });
  closeBtn.addEventListener("click", function () { close(); });
  resetBtn.addEventListener("click", function () { resetConvo(); });
  backdrop.addEventListener("click", function () { close(); }); // big, obvious way out on mobile

  // Keep the sheet glued to the visible viewport as the keyboard opens/closes or on rotate.
  if (window.visualViewport) {
    window.visualViewport.addEventListener("resize", applyLayout);
    window.visualViewport.addEventListener("scroll", applyLayout);
  }
  window.addEventListener("resize", applyLayout);
  window.addEventListener("orientationchange", function () { setTimeout(applyLayout, 200); });
  input.addEventListener("focus", function () { setTimeout(function () { applyLayout(); scrollToBottom(); }, 120); });

  /* ---------- attention badge (replaces the old timed auto-open) ----------
     Draw the eye to the launcher with a notification dot + soft pulse instead of
     taking over the screen. It clears the first time the visitor opens the chat
     and won't show again for the rest of the session. */
  var SEEN_KEY = "exosAssistantSeen";
  function badgeSeen() { try { return !!sessionStorage.getItem(SEEN_KEY); } catch (e) { return false; } }
  function showBadge() { if (!openState && !badgeSeen()) bubble.classList.add("is-alert"); }
  function clearBadge() {
    bubble.classList.remove("is-alert");
    try { sessionStorage.setItem(SEEN_KEY, "1"); } catch (e) {}
  }
  // Small delay so the badge animates in after the page settles — that motion is what catches the eye.
  setTimeout(showBadge, 1200);

  /* ---------- send + stream ---------- */
  function popUserTurn() {
    if (messages.length && messages[messages.length - 1].role === "user") messages.pop();
  }

  form.addEventListener("submit", async function (e) {
    e.preventDefault();
    if (input.disabled) return; // a chip click fires requestSubmit() even while a reply streams
    var q = input.value.trim();
    if (!q) return;
    var myGen = convoGen;
    removeChips(); // conversation started — the starter questions have done their job
    input.value = "";
    messagesEl.setAttribute("aria-live", "off"); // avoid per-token SR spam while streaming
    var userEl = addBubble("user", q);
    messages.push({ role: "user", content: q });
    saveConvo(); // persist the question now, in case they navigate away mid-reply
    var out = addBubble("assistant", "");
    out.classList.add("is-typing");

    // Watchdog: if the stream goes silent for STREAM_TIMEOUT_MS, abort so we recover instead
    // of leaving the widget locked behind a half-open connection. (Constructed BEFORE the
    // inputs are disabled so nothing can throw between disabling and the finally re-enable.)
    var ctrl = new AbortController();
    activeCtrl = ctrl;
    var watchdog;
    function arm() { clearTimeout(watchdog); watchdog = setTimeout(function () { try { ctrl.abort(); } catch (e) {} }, STREAM_TIMEOUT_MS); }

    input.disabled = true; sendBtn.disabled = true; // block concurrent sends while streaming

    // Roll the failed turn back so the customer can just hit Send again: their text goes
    // back into the input and the orphaned bubble is dropped, keeping the on-screen
    // transcript consistent with the history that's actually sent to the worker.
    function rollback() {
      popUserTurn();
      if (userEl && userEl.parentNode) userEl.parentNode.removeChild(userEl);
      userEl = null;
      if (!input.value) input.value = q;
    }
    function fail(msg) {
      if (myGen !== convoGen) return; // conversation was reset mid-flight — leave the fresh one alone
      out.classList.remove("is-typing");
      rollback();
      saveConvo();
      messagesEl.setAttribute("aria-live", "polite");
      out.innerHTML = mdToHtml(msg || CONTACT_MSG);
      scrollToBottom(true);
    }

    try {
      arm();
      var res = await fetch(endpoint, {
        method: "POST",
        headers: { "content-type": "application/json" },
        // page lets the bot resolve "this door / this page" for wherever the customer is.
        body: JSON.stringify({
          messages: messages,
          page: { path: (location.pathname || "/").slice(0, 200), title: (document.title || "").slice(0, 200) }
        }),
        signal: ctrl.signal
      });
      if (res.status === 429) {
        var info = null;
        try { info = await res.json(); } catch (err) { /* older worker sent plain text */ }
        // The minute cap clears in seconds; the day cap doesn't — don't tell a day-capped
        // visitor to keep retrying for an hour.
        fail(info && info.scope === "day" ? DAY_LIMIT_MSG : "You're sending messages a bit fast. Give it a few seconds and try again.");
        return;
      }
      if (!res.ok || !res.body) { fail(); return; }
      var reader = res.body.getReader(), dec = new TextDecoder(), buf = "", acc = "", errored = false, retryable = false, truncated = false;
      // The reply is accumulated silently behind the typing indicator and shown COMPLETE
      // (owner preference 2026-07-02: no token-by-token "spam text" appearing in the chat).
      while (true) {
        arm(); // reset the watchdog on every chunk
        var r = await reader.read();
        if (r.done) break;
        buf += dec.decode(r.value, { stream: true });
        var parts = buf.split("\n\n");
        buf = parts.pop();
        for (var i = 0; i < parts.length; i++) {
          var line = parts[i].split("\n").find(function (l) { return l.indexOf("data:") === 0; });
          if (!line) continue;
          var payload = line.slice(5).trim();
          if (payload === "[DONE]") continue;
          try {
            var obj = JSON.parse(payload);
            if (obj.error) { errored = true; if (obj.retryable) retryable = true; }
            else if (obj.truncated) truncated = true;
            else if (obj.text) { acc += obj.text; }
          } catch (err) { /* ignore non-JSON keep-alives */ }
        }
      }
      if (myGen !== convoGen) return; // conversation was reset mid-flight — discard this reply
      out.classList.remove("is-typing");
      messagesEl.setAttribute("aria-live", "polite");
      // Pull the model's suggested follow-ups out of the reply; the trailer renders as
      // tappable chips, never as text. Ordered fallbacks: end-anchored trailer, then a
      // standalone trailer line elsewhere (model put an image after it), then a fragment
      // clipped mid-stream (bounded so it can never eat real answer text).
      var followups = [];
      function captureList(list) {
        followups = list.split("|").map(function (s) { return s.trim(); }).filter(Boolean).slice(0, 3);
        return "";
      }
      var beforeStrip = acc;
      acc = acc.replace(/\s*\[suggest:([^\]]*)\]\s*$/i, function (_, l) { return captureList(l); });
      if (acc === beforeStrip) {
        acc = acc.replace(/^[ \t]*\[suggest:([^\]\n]*)\][ \t]*$/im, function (_, l) { return captureList(l); });
        if (acc === beforeStrip) acc = acc.replace(/\s*\[suggest:[^\]]{0,150}$/i, "");
      }
      acc = acc.replace(/\s+$/, "");
      if (acc) {
        // Keep whatever arrived — a mostly-good answer beats an error screen. If the reply
        // was cut short or the connection hiccuped, say so under it instead of wiping it.
        messages.push({ role: "assistant", content: acc });
        var note = "";
        if (truncated) note = NOTE_TRUNCATED;
        else if (errored) note = NOTE_HICCUP;
        out.innerHTML = mdToHtml(acc) + note;
        if (followups.length) renderChipRow(followups);
        // A tall answer should be read from the top; short ones pin to the bottom as usual.
        if (out.offsetHeight > messagesEl.clientHeight - 40) messagesEl.scrollTop = out.offsetTop - messagesEl.offsetTop - 8;
        else scrollToBottom(true);
        // Images finish loading after render and grow the bubble; keep the view pinned.
        var imgs = out.getElementsByTagName("img");
        for (var k = 0; k < imgs.length; k++) imgs[k].addEventListener("load", function () { scrollToBottom(); });
      } else if (errored && retryable) {
        fail(BUSY_MSG);
      } else {
        fail();
      }
      saveConvo();
    } catch (err) {
      // Watchdog aborts and network drops land here — if most of an answer already
      // streamed, keep it with the hiccup note (same rule as the clean-end path) instead
      // of wiping a nearly complete reply off the screen.
      if (myGen !== convoGen) { /* reset mid-flight — discard */ }
      else if (typeof acc === "string" && acc) {
        out.classList.remove("is-typing");
        acc = acc.replace(/\s*\[suggest:[^\]]*\]?\s*$/i, ""); // drop a whole or clipped trailer
        messages.push({ role: "assistant", content: acc });
        messagesEl.setAttribute("aria-live", "polite");
        out.innerHTML = mdToHtml(acc) + NOTE_HICCUP;
        saveConvo();
        scrollToBottom();
        // Images finish loading after render and grow the bubble; keep the view pinned.
        var pimgs = out.getElementsByTagName("img");
        for (var p = 0; p < pimgs.length; p++) pimgs[p].addEventListener("load", function () { scrollToBottom(); });
      } else {
        fail();
      }
    } finally {
      clearTimeout(watchdog);
      if (activeCtrl === ctrl) activeCtrl = null;
      input.disabled = false; sendBtn.disabled = false; // re-enable after the reply finishes/fails
      if (!isMobile() && openState) input.focus(); // desktop: ready for the follow-up without re-clicking
    }
  });
})();
